import { useQuery } from "@tanstack/react-query";

import { getAdminFarmOrganicFertilizerProduction } from "services";

import { GET_ADMIN_FARM_ORGANIC_FERTILIZER_PRODUCTION } from "consts";

import { FarmOrganicFertilizerProductionEntry } from "models";

export const useGetAdminFarmOrganicFertilizerProduction = ({ farmId }: { farmId?: string }) =>
  useQuery<FarmOrganicFertilizerProductionEntry[]>({
    queryKey: [GET_ADMIN_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId],
    queryFn: () => getAdminFarmOrganicFertilizerProduction({ farmId: farmId! }),
    enabled: !!farmId,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
